import React, { useEffect, useRef, useState } from 'react'
import PlayIcon from 'assets/play_icon.svg'
import { useMediaPlayback } from 'common/hooks/useMediaPlayback'
import ReactPlayer from 'react-player'
import { BsPause, BsPlay, BsPlayFill } from 'react-icons/bs'

interface InterviewProps {
  image: string
  title?: string
  description: string
  url: string
  id: string
}

const SvgIcon = ({ src, alt, ...props }) => (
  <img src={src} alt={alt} {...props} />
)

const InterviewCard: React.FC<InterviewProps> = ({
  title,
  description,
  url,
  id,
}) => {
  const { thumbnail, playerRef, onPlay, isPlaying, progress, onTimestamps } =
    useMediaPlayback({ url })

  console.log(progress)

  return (
    <div>
      <div className='relative w-full md:h-[287px] h-[200px] bg-black !rounded-[10px] overflow-hidden'>
        <ReactPlayer
          ref={playerRef}
          url={url}
          controls={false}
          playing={isPlaying}
          light={!isPlaying && thumbnail}
          width={'100%'}
          height={'100%'}
          onProgress={onTimestamps}
        />
      </div>
      <div className=''>
        <div className='mt-[24px] mb-[40px] '>
          <p className=' md:!text-[16px] '>
            <span className='font-bold'> {title}</span>:{' '}
            {description.slice(0, 300)}...
          </p>
        </div>
        <div className='flex items-center justify-between'>
          <div className='flex items-center flex-row'>
            <button
              onClick={onPlay}
              className='flex items-center bg-[#F4F4F4] text-[#A0ABBE] rounded-full p-2 hover:bg-[#E4E4E4] transition-colors duration-200 shadow-[0px_0.4px_4px_rgba(0,0,0,0.25)]'
            >
              {!isPlaying ? <BsPlayFill size={16} /> : <BsPause size={16} />}
            </button>
            <span className='ml-[12px] text-[16px] text-[#101828] '>
              Play this interview
            </span>
          </div>
          <span className='text-xs sm:text-sm text-gray-600'>{progress}</span>
        </div>
      </div>
    </div>
  )
}

export default InterviewCard
